import React from "react";
import PropTypes from "prop-types";

import { FormTextField } from "ui/Form";

const LimitsContent = ({ limitFields }) => {
  const renderLimit = ([id, name]) => (
    <FormTextField
      key={`limit-${id}-value`}
      name={`limits[${id}]`}
      label={name}
      type="number"
    />
  );

  return Object.entries(limitFields).map(renderLimit);
};

LimitsContent.propTypes = {
  limitFields: PropTypes.object.isRequired,
};

export default LimitsContent;
